<script setup lang="ts">
import type { CaseFile } from '@/modules/Cases/types'
import InlineFile from '@/sharedComponents/InlineFile.vue'
import { useFileType } from '@/sharedComposables/useFileType'
import { computed } from 'vue'

const props = defineProps<{ file: CaseFile }>()

// For case files, we use the URL field that contains the presigned URL
const fileUrl = computed(() => props.file.url || null)

const fileType = useFileType(fileUrl)

const filename = computed(() => props.file.name)
</script>

<template>
  <div class="flex h-full w-full flex-col">
    <!-- File Content -->
    <div class="go-scrollbar min-h-0 grow overflow-y-auto">
      <template v-if="fileUrl && fileType">
        <InlineFile
          :file-type="fileType"
          :url="fileUrl"
        />
      </template>
      <div
        v-else
        class="flex h-full items-center justify-center text-text-subtle"
      >
        <div class="text-center">
          <p class="text-sm-12px-default">File preview not available</p>
          <p class="text-xs-11px-default">
            {{ filename }}
          </p>
        </div>
      </div>
    </div>
  </div>
</template>
